// extracted by mini-css-extract-plugin
export default {"wrapper":"PredictionsMenu_wrapper--J9t","item":"PredictionsMenu_item--OlV","activeItem":"PredictionsMenu_activeItem--Vzu","filledStep":"PredictionsMenu_filledStep--KLx"};